/* eslint-disable default-param-last */
import { SET_RUNTIME_VARIABLE } from '../constants/variables';

export default function runtime(state = {}, action: any) {
  switch (action.type) {
    case SET_RUNTIME_VARIABLE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    default:
      return state;
  }
}
